import { IStorage } from "../app/user-interface";

import { IDBPDatabase, openDB } from 'idb';

const defaultKeyStoreName = 'keyval';

export class AppStorage implements IStorage {
  protected dbKeyValPromise:Promise<IDBPDatabase>

  constructor() {
    this.initDb();
  }

  protected initDb() {
    this.dbKeyValPromise = openDB('keyval-store', 1, {
      upgrade(db) {
        db.createObjectStore('keyval');
      },
    });
  }

  async keyGet(key:string, keySetName?:string):Promise<any> {
    return (await this.getKeySetDatabase(keySetName)).get(defaultKeyStoreName, key);
  }

  async keySet(key:string, value:any, keySetName?:string):Promise<any> {
    return (await this.getKeySetDatabase(keySetName)).put(defaultKeyStoreName, value, key);
  }

  async keyDelete(key:string, keySetName?:string):Promise<any> {
    return (await this.getKeySetDatabase(keySetName)).delete(defaultKeyStoreName, key);
  }

  async keyClearAll(keySetName?:string):Promise<any> {
    return (await this.getKeySetDatabase(keySetName)).clear(defaultKeyStoreName);
  }

  async  keyGetKeys(keySetName?:string):Promise<string[]> {
    return (await (await this.getKeySetDatabase(keySetName)).getAllKeys(defaultKeyStoreName)).map(value => value.toString());
  }

  protected async getKeySetDatabase(name:string = defaultKeyStoreName):Promise<IDBPDatabase> {
    if (name === defaultKeyStoreName) {
      return this.dbKeyValPromise;
    }

  }
}